import apiClient from './client'
import { MemberUser, CreateMemberUserInput } from '@/types/admin'
import type { Suggestion } from '@brent/shared/types'

export const usersApi = {
  list: async () => {
    const response = await apiClient.get<{ users: MemberUser[] }>('/admin/users')
    return response.users
  },
  getSuggestions: async (username: string) => {
    const response = await apiClient.get<{ suggestions: Suggestion[] }>(
      `/admin/users/${username}/suggestions`,
    )
    return response.suggestions
  },
  create: (data: CreateMemberUserInput) => apiClient.post<MemberUser>('/admin/users', data),
  delete: (username: string) => apiClient.delete<void>(`/admin/users/${username}`),
  resendWelcomeEmail: (username: string) =>
    apiClient.post<{
      message: string
      email_sent: boolean
      email_error: string | null
    }>(`/admin/users/${username}/resend-welcome`, {}),
}
